import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import SafeDrivingGuideBottomSheet from '@di-shared/features/safe-driving-LN/SafeDrivingGuideBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 1000;

function SafeDrivingGuideBottomSheetPage() {
  const {fromDate, toDate} = (window as any).data as {fromDate: string; toDate: string};
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <SafeDrivingGuideBottomSheet
        fromDate={fromDate}
        toDate={toDate}
      />
    </BottomSheetWebViewWrapper>
  );
}

export default SafeDrivingGuideBottomSheetPage;
